import { observer } from 'mobx-react-lite';
import { CardMedia, Dialog, DialogContent } from '@mui/material';

type InspectionImageModalProps = {
  url: string;
  onCancel: () => void;
};

const InspectionImageModal = observer(({ url, onCancel }: InspectionImageModalProps) => {
  return (
    <Dialog
      open
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          position: 'absolute',
          top: '15%',
          left: '50%',
          transform: 'translateX(-50%)',
        },
      }}
      onClose={onCancel}
    >
      <DialogContent sx={{ flexGrow: 1, overflow: 'auto' }}>
        <CardMedia
          component="img"
          src={url}
          alt="Property Photo"
          sx={{
            maxHeight: '60vh',
            width: '100%',
            objectFit: 'contain',
            borderRadius: '4px',
          }}
        />
      </DialogContent>
    </Dialog>
  );
});

export { InspectionImageModal };
